'use strict';

const Analytics = require('./analytics');

function getListType (container) {
    var list = '';
    if (container.parents('.carousel-einstein-recently-viewed').length > 0) {
        list = 'recently_viewed';
    } else if (container.parents('.hp-four-slider').length > 0) {
        list = 'home';
    } else if (container.parents('.completeYourLookContainer').length > 0) {
        list = 'complete_your_look';
    } else if (container.parents('.wishlistItemCards').length > 0) {
        list = 'wishlist';
    } else if (container.parents('.js-youMayAlsoLikeContainer').length) {
        list = 'you_may_also_like';
    } else if (container.parents('.suggested-products-slider').length > 0) {
        list = 'suggested_products';
    } else if (container.parents('.cart-line-item').length > 0) {
        list = 'cart';
    } else if (container.parents('.miniCartCrossSellContainer-carousel').length > 0) {
        list = 'complete_your_look_minicart';
        if ($('#miniCartCrossSellContainer').find('.analytics-minicart-promo').length > 0) {
            list = 'complete_your_promo_minicart';
        }
    }
    return list;
}

function getSortingType (sortingContainer) {
    var sortingSelected = sortingContainer.getAttribute('id');
    var formattedSorting = sortingSelected.replaceAll('-', '_');

    return formattedSorting;
}

/* eslint-disable no-undef */
class AnalyticsListings extends Analytics {
    pushIndexesFor (lists) {
        let indexes = {};
        for (let i = 0; i < lists.length; i++) {
            indexes[lists[i].class] = 0;
        }
        return indexes;
    }

    init (globalContainer, helperContainer) {
        this.logName = 'AnalyticsListings';
        super.init(globalContainer, helperContainer);
        this.listingItemsBaseClass = '.analytics.pageType.listing';
        this.analyticsDataContainer = '.analytics.productListingItem';
        this.pushedSlickSlides = [];
        this.pushedItems = [];
        this.completeYourLookPushedItems = [];
        this.cmBestSellersPushedItems = [];
        this.cmNewArrivalsPushedItems = [];
        this.pushedSkus = [];
        this.pushedHomeSkus = [];
        this.pushedRecentlySkus = [];
        this.listsAvailable = this.helper.getAvailableListTypes(this.listingItemsBaseClass);
        this.pushedIndexes = this.pushIndexesFor(this.listsAvailable);
        this.analyticsSuggestionShouldTrigger = true;

        this.prepareObservers();
        // wait for the async call to cross sell to push lists when completeYourLook is available
        if (this.listsAvailable.filter(function (i) { return i.class === 'completeYourLook'; }).length === 0) {
            this.prepareProductObservers();
            this.pushAllLists();
        }
        this.prepareBestSellersObservers();
        this.prepareTilesObservers();
    }

    fillListData (wrapper) {
        let searchContainer = wrapper.associatedObject === '.analytics-search-results' ? '.analytics-search-results' : '.search-results';
        let container;

        if (wrapper.value === 'wishlist') {
            container = $(wrapper.associatedObject).closest('.wishlist-container').find(this.analyticsDataContainer);
        } else if (wrapper.class === 'cmBestSellers' || wrapper.class === 'cmNewArrivals') {
            container = $(wrapper.associatedObject).find('.cm-productItem ' + this.analyticsDataContainer);
        } else {
            container = $(wrapper.associatedObject).closest(searchContainer).find(this.analyticsDataContainer);
        }

        for (let i = 0; i < container.length; i++) {
            container.eq(i).attr('data-index', i);
            container.eq(i).attr('data-item_list_name', wrapper.value);
            container.eq(i).attr('data-item_list_id', this.helper.getListId());

            if (container.eq(i).closest('.slick-slide').length) {
                this.pushedSlickSlides.push(container.eq(i).closest('.slick-slide').data('slickIndex'));
            }
        }
    }

    fillAllListData () {
        let _self = this;
        this.listsAvailable.forEach(function (listing) {
            _self.fillListData(listing);
        });
    }

    getInfo (wrapper) {
        this.fillListData(wrapper);

        let items = [];
        let container = $(wrapper.associatedObject).find(this.analyticsDataContainer);

        // Fallback value for plp best practises naming convention
        if (wrapper.associatedObject === '.search-results' && !container.length) {
            wrapper.associatedObject = '.analytics-search-results';

            this.fillAllListData(wrapper);
            container = $(wrapper.associatedObject).find(this.analyticsDataContainer);
        }

        // Complete your look needs to reset the pushed indexes, for the change color in PDP
        if (wrapper.value === 'complete_your_look') {
            this.completeYourLookPushedItems = [];
        }

        var list = '';
        if (localStorage.getItem('horizontalFilter') && localStorage.getItem('horizontalFilter') === 'true') {
            list = 'filter_applied';
            localStorage.setItem('horizontalFilter', '');
        } else {
            list = getListType(container);
        }
        if (list === 'complete_your_look_minicart' || list === 'complete_your_promo_minicart') {
            if (!Foundation.MediaQuery.atLeast('medium')) {
                container = $(wrapper.associatedObject).closest('.js-mainHeader-minicart.pdp.open').find(this.analyticsDataContainer);
            } else {
                container = $(wrapper.associatedObject).closest('.js-mainHeader-minicart.open:not(".pdp")').find(this.analyticsDataContainer);
            }
        }

        // Check if the container is in a slick or not, to put only the items to analyzed.
        let allProducts = $(wrapper.associatedObject).find('.slick-slide ' + this.analyticsDataContainer);
        if (allProducts.length > 0) {
            container = $(wrapper.associatedObject).find('.slick-slide.slick-active ' + this.analyticsDataContainer);
        }
        // Check if the container is an internal coremedia carousel initialized without using a slick or a swiper slider
        let allCmProducts = $(wrapper.associatedObject).find('.cm-productItem ' + this.analyticsDataContainer);
        if (allCmProducts.length > 0) {
            container = $(wrapper.associatedObject).find('.cm-productItem.active-cm-slide ' + this.analyticsDataContainer);
        }

        const itemListName = list !== '' ? list : wrapper.value;
        let prefix = null;
        if (wrapper.value === 'you_may_also_like') {
            prefix = 'google';
        }
        const itemListId = this.helper.getListId(wrapper.associatedObject, prefix);
        for (let i = 0; i < container.length; i++) {
            let obj = container.eq(i).data();
            obj.item_list_name = itemListName;
            obj.item_list_id = itemListId;
            items.push(this.helper.formatProductForAnalytics(obj));
            if (wrapper.value === 'complete_your_look') {
                this.completeYourLookPushedItems.push(i);
            } else if (wrapper.class === 'cmBestSellers') {
                this.cmBestSellersPushedItems.push(container.eq(i).attr('data-index'));
            } else if (wrapper.class === 'cmNewArrivals') {
                this.cmNewArrivalsPushedItems.push(container.eq(i).attr('data-index'));
            } else {
                this.pushedItems.push(i);
                if (list === 'home') {
                    this.pushedHomeSkus.push(obj.item_id + obj.item_variant);
                }
            }
        }

        var _self = this;

        $('body').on('afterChange', '.js-suggestedProducts, ' + wrapper.associatedObject, function (event, slick, currentSlide, nextSlide) {
            let allActive = $(wrapper.associatedObject).find('.slick-slide.slick-active ' + _self.analyticsDataContainer);

            // All elements for position
            let allProducts = $(wrapper.associatedObject).find('.slick-slide ' + _self.analyticsDataContainer);
            let totalProductsNumber = allProducts.length;

            let items = [];
            let sortingContainer = document.querySelector('.sort-order-item input[type="radio"]:checked');
            var list = getListType(allActive);
            const itemListId = _self.helper.getListId(null, 'sfcc');
            for (let i = 0; i < allActive.length; i++) {
                let obj = allActive.eq(i).data();
                if (!!sortingContainer) {
                    obj.item_list_name = getSortingType(sortingContainer);
                } else {
                    obj.item_list_name = list;
                }
                obj.item_list_id = itemListId;
                var item = _self.helper.formatProductForAnalytics(obj);
                item.index = list === 'home' ? _self.pushedHomeSkus.length : allActive.eq(i).parents('.slick-slide').data('slick-index');
                if (item.index < 0) {
                    item.index += totalProductsNumber;
                }
                if (wrapper.value !== 'complete_your_look' && _self.pushedItems.indexOf(item.index) === -1) {
                    if (list === 'home') {
                        if (_self.pushedHomeSkus.indexOf(obj.item_id + obj.item_variant) === -1) {
                            items.push(item);
                            _self.pushedItems.push(item.index);
                            _self.pushedHomeSkus.push(obj.item_id + obj.item_variant);
                        }
                    } else {
                        items.push(item);
                        _self.pushedItems.push(item.index);
                    }
                } else if (wrapper.value === 'complete_your_look' && _self.completeYourLookPushedItems.indexOf(item.index) === -1) {
                    items.push(item);
                    _self.completeYourLookPushedItems.push(item.index);
                }
            }
            _self.log('Pushing for ' + wrapper.value, true);

            if (items.length > 0) {
                let pushObject = {
                    'event': 'view_item_list',
                    'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                    'ecommerce': {
                        'currency': _self.helperData.currency,
                        'item_list_name': list,
                        'item_list_id': itemListId,
                        'items': items
                    }
                };

                _self.push({ecommerce: null});
                _self.push(pushObject);
                _self.pushedIndexes[wrapper.class] = items.length;
                _self.log('Indexes pushed to: ', true);
                _self.log(_self.pushedIndexes);
            }
        });

        $(wrapper.associatedObject).on('scrollend', function () {
            let itemListName;
            let itemListId;
            let items = [];
            let allActiveCmProducts = $(wrapper.associatedObject).find('.cm-productItem.active-cm-slide ' + _self.analyticsDataContainer);
            for (let i = 0; i < allActiveCmProducts.length; i++) {
                if (wrapper.class === 'cmBestSellers' && _self.cmBestSellersPushedItems.indexOf(allActiveCmProducts.eq(i).attr('data-index')) > -1) continue;
                else if (wrapper.class === 'cmNewArrivals' && _self.cmNewArrivalsPushedItems.indexOf(allActiveCmProducts.eq(i).attr('data-index')) > -1) continue;
                itemListName = allActiveCmProducts.eq(i).attr('data-item_list_name');
                itemListId = allActiveCmProducts.eq(i).attr('data-item_list_id');
                let obj = allActiveCmProducts.eq(i).data();
                obj.item_list_name = itemListName;
                obj.item_list_id = itemListId;
                obj.index = allActiveCmProducts.eq(i).attr('data-index');
                let item = _self.helper.formatProductForAnalytics(obj);
                items.push(item);
                if (wrapper.class === 'cmBestSellers') _self.cmBestSellersPushedItems.push(allActiveCmProducts.eq(i).attr('data-index'));
                else if (wrapper.class === 'cmNewArrivals') _self.cmNewArrivalsPushedItems.push(allActiveCmProducts.eq(i).attr('data-index'));
            }
            if (items.length > 0) {
                _self.log('Pushing for ' + wrapper.value, true);
                let pushObject = {
                    'event': 'view_item_list',
                    'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                    'ecommerce': {
                        'currency': _self.helperData.currency,
                        'item_list_name': itemListName,
                        'item_list_id': itemListId,
                        'items': items
                    }
                };
                _self.push({ecommerce: null});
                _self.push(pushObject);
                _self.pushedIndexes[wrapper.class] += items.length;
                _self.log('Indexes pushed to: ', true);
                _self.log(_self.pushedIndexes);
            }
        });

        return {
            items: items,
            itemListName: itemListName,
            itemListId: itemListId
        };
    }

    pushData (wrapper) {
        let info = this.getInfo(wrapper);
        let items = info.items;
        if (items.length === 0) {
            return;
        }

        let itemsToPush = items.slice(this.pushedIndexes[wrapper.class], items.length);
        if (wrapper.value === 'listing') {
            if (itemsToPush.length === 0) {
                return;
            }
        } else {
            itemsToPush = items;
        }

        this.log('Pushing for ' + wrapper.value, true);

        // Pointer for array product
        for (var j = 0; j < items.length; j++) {
            items[j].index = j;
        }

        this.pushObjectMax({
            items: items,
            i: 0,
            l: 8,
            itemListName: info.itemListName,
            itemListId: info.itemListId
        });

        this.pushedIndexes[wrapper.class] = items.length;
        this.log('Indexes pushed to: ', true);
        this.log(this.pushedIndexes);
    }

    pushAllLists () {
        let _self = this;

        if (this.listsAvailable.length === 0) {
            return;
        }
        this.fillAllListData();

        this.listsAvailable.forEach(function (listing) {
            _self.pushData(listing);
        });
    }

    pushList (list) {
        let _self = this;

        if (this.listsAvailable.length === 0) {
            return;
        }
        this.fillAllListData();

        this.listsAvailable.forEach(function (listing) {
            if (listing.value === list) {
                _self.pushData(listing);
            }
        });
    }

    pushSelectInteraction (clickedContainer, itemIndex) {
        this.fillAllListData();

        let container = clickedContainer.find(this.analyticsDataContainer);
        let additionalDataContainer = container.find('.clickAdditionalAttributes');
        let pushData = { ...container.data(), ...additionalDataContainer.data() };

        if (pushData && (pushData.index === undefined || pushData.index === null || pushData.index === '')) {
            pushData.index = itemIndex;
        }

        let list = pushData.item_list_name;

        let localStorageListType = localStorage.getItem('listtype');
        if (localStorageListType === 'product_name_ascending' || localStorageListType === 'product_name_descending' || localStorageListType === 'landing') {
            list = localStorageListType;
        }

        let sortingContainer = document.querySelector('.sort-order-item input[type="radio"]:checked');
        if (!!sortingContainer) {
            list = getSortingType(sortingContainer);
        }

        if (!list || !list.length || list === '') {
            return;
        }

        if (list === 'listing' ||
            list === 'search' ||
            list === 'category' ||
            list === 'wishlist' ||
            list === 'filter_applied' ||
            list === 'best_sellers' ||
            list === 'sorting_decreasing_price' ||
            list === 'sorting_increasing_price' ||
            list === 'new_arrivals' ||
            list === 'complete_your_look_minicart' ||
            list === 'complete_your_promo_minicart' ||
            list === 'shop_the_look' ||
            list === 'complete_your_look' ||
            list === 'landing' ||
            list === 'carousel_home' ||
            list === 'buy_it_again' ||
            list === 'similar_products') {
            try {
                localStorage.setItem('listtype', list);
            } catch (e) {}
        }

        this.log('Pushing click impression for: ' + pushData.id, true);

        pushData.item_list_name = list;
        var products = this.helper.formatProductForAnalytics(pushData);

        if (!list) {
            list = 'unknown_source';
        }

        if (!products.index && container.closest('.analytics-quickview').length !== 0 && container.closest('.add-freegift').length === 0 && list !== 'cart') {
            try {
                products.index = parseInt(localStorage.getItem('lastClickedPosition')) || 0;
            } catch (e) {
                products.index = 0;
            }
        }

        if (!products.item_list_name && container.closest('.js-einsteinProducts').find('.suggestedProducts').length) {
            products.item_list_name = 'suggested_products';
        }

        this.helper.storeGtmData({
            item_id: pushData.item_id,
            item_variant: pushData.item_variant,
            item_list_name: products.item_list_name,
            item_list_id: products.item_list_id,
            index: products.index
        });

        let pushObject = {
            'event': 'select_item',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': products.item_list_name,
                'item_list_id': products.item_list_id,
                'items': [products]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);

        try {
            localStorage.setItem('lastClickedPosition', products.index);
            localStorage.setItem('lastCategory', products.category);
        } catch (e) {}
    }

    pushOrderAgainViewItem (clickedContainer) {
        this.fillAllListData();

        let container = $(clickedContainer).find(this.analyticsDataContainer);
        let additionalDataContainer = container.find('.clickAdditionalAttributes');

        let pushData = { ...container.data(), ...additionalDataContainer.data() };
        let list = pushData.item_list_name;
        delete pushData.item_list_name;

        let localStorageListType = localStorage.getItem('listtype');
        if (localStorageListType === 'landing') {
            list = localStorageListType;
        }

        if (list === 'listing' ||
            list === 'search' ||
            list === 'category' ||
            list === 'wishlist' ||
            list === 'filter_applied' ||
            list === 'best_sellers' ||
            list === 'sorting_decreasing_price' ||
            list === 'sorting_increasing_price' ||
            list === 'new_arrivals' ||
            list === 'buy_it_again') {
            try {
                localStorage.setItem('listtype', list);
                localStorage.setItem('listtypeforcart', list);
            } catch (e) {}
        }

        this.log('Pushing click impression for: ' + pushData.id, true);

        pushData.item_list_name = list;
        pushData.item_list_id = this.helper.getListId(clickedContainer);
        var products = this.helper.formatProductForAnalytics(pushData);

        try {
            localStorage.setItem('lastClickedPosition', products.index);
        } catch (e) {}

        let productsDetail = {
            item_name: products['item_name'],
            item_id: products['item_id'],
            price: products.price,
            item_brand: products['item_brand'],
            item_category: products['item_category'],
            item_category2: products['item_category2'],
            item_category3: products['item_category3'],
            item_category4: products['item_category4'],
            item_category5: products['item_category5'],
            item_list_name: products['item_list_name'],
            item_list_id: products['item_list_id'],
            item_variant: products['item_variant'],
            index: products.index,
            coupon: products.coupon,
            item_availability: products['item_availability'],
            item_on_sale: products['item_on_sale'],
            item_sustainable: products['item_sustainable'],
            size: '',
            item_color: products['item_color'],
            item_sfcc: products['item_sfcc'],
            item_customizaiton: products['item_customization'],
            discount: products['discount']
        };

        let pushObject = {
            event: 'view_item',
            ss_event_id: Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            ecommerce: {
                currency: this.helperData.currency,
                item_list_name: list,
                item_list_id: this.helper.getListId(clickedContainer),
                items: [productsDetail]
            },
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushSelectQuickViewInteraction (clickedContainer) {
        this.fillAllListData();

        let container = $(clickedContainer).find(this.analyticsDataContainer);
        let additionalDataContainer = container.find('.clickAdditionalAttributes');

        let pushData = { ...container.data(), ...additionalDataContainer.data() };
        let list = pushData.item_list_name;
        delete pushData.item_list_name;

        let localStorageListType = localStorage.getItem('listtype');
        if (localStorageListType === 'landing') {
            list = localStorageListType;
        }

        if (list === 'listing' ||
            list === 'search' ||
            list === 'category' ||
            list === 'wishlist' ||
            list === 'filter_applied' ||
            list === 'best_sellers' ||
            list === 'sorting_decreasing_price' ||
            list === 'sorting_increasing_price' ||
            list === 'new_arrivals' ||
            list === 'buy_it_again') {
            try {
                localStorage.setItem('listtype', list);
                localStorage.setItem('listtypeforcart', list);
            } catch (e) {}
        }

        this.log('Pushing click impression for: ' + pushData.id, true);

        pushData.item_list_name = list;
        pushData.item_list_id = this.helper.getListId(clickedContainer);
        var products = this.helper.formatProductForAnalytics(pushData);

        try {
            localStorage.setItem('lastClickedPosition', products.index);
        } catch (e) {}

        let productsDetail = {
            item_name: products['item_name'],
            item_id: products['item_id'],
            price: products.price,
            quantity: 1,
            item_brand: products['item_brand'],
            item_category: products['item_category'],
            item_variant: products['item_variant'],
            index: products.index,
            size: '',
            item_on_sale: products['item_on_sale'],
            item_availability: products['item_availability'],
            coupon: products.coupon,
            item_color: products['item_color'],
            item_sfcc: products['item_sfcc'],
            item_category2: products['item_category2'],
            item_sustainable: products['item_sustainable'],
            discount: products['discount']
        };

        let pushObject = {
            event: 'view_item',
            ss_event_id: Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            ecommerce: {
                currency: this.helperData.currency,
                item_list_name: list,
                item_list_id: this.helper.getListId(clickedContainer),
                items: [productsDetail]
            },
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    getBonusProductInfo (rawProduct) {
        const productBaseInfo = this.helper.getProductBaseInfo(rawProduct);
        const productGender = this.helper.getProductGender(rawProduct);

        let product = {
            item_id: productBaseInfo.id ? productBaseInfo.id : rawProduct.id,
            item_name: this.helper.formatString(rawProduct.nameEng),
            price: rawProduct.bonusUnitPriceValue,
            quantity: rawProduct.selectedQuantity || '',
            item_brand: 'intimissimi',
            item_category1: rawProduct.categoryPath,
            item_variant: productBaseInfo.color,
            item_size: productBaseInfo.size,
            item_on_sale: 'yes',
            item_availability: 'available',
            coupon: 'promo' in productBaseInfo && productBaseInfo.promo ? productBaseInfo.promo : 'no_promotion',
            item_color: rawProduct.colorFamilyEng ? rawProduct.colorFamilyEng : '',
            item_sfcc: rawProduct.id,
            item_category2: productGender,
            item_list_name: 'free_product',
            item_list_id: this.helper.getListId(),
            item_sustainable: rawProduct.isGreen ? 'sustainable_item' : 'classic_item',
            discount: rawProduct.price && rawProduct.price.sales ? rawProduct.price.sales.value.toFixed(2) : 0.00
        };
        product = this.helper.formatProductForAnalytics(product);
        return product;
    }

    pushBonusProductDetails (data) {
        data.products.forEach((rawProduct, index) => {
            const productBaseInfo = this.helper.getProductBaseInfo(rawProduct);
            const productGender = this.helper.getProductGender(rawProduct);

            let product = {
                item_id: productBaseInfo.id ? productBaseInfo.id : rawProduct.id,
                item_name: this.helper.formatString(rawProduct.nameEng),
                price: rawProduct.bonusUnitPriceValue,
                quantity: rawProduct.selectedQuantity || '',
                item_brand: 'intimissimi',
                item_variant: productBaseInfo.color,
                item_size: productBaseInfo.size,
                item_on_sale: 'yes',
                item_availability: 'available',
                coupon: 'promo' in productBaseInfo && productBaseInfo.promo ? productBaseInfo.promo : 'no_promotion',
                item_color: rawProduct.colorFamilyEng ? rawProduct.colorFamilyEng : '',
                item_sfcc: rawProduct.id,
                item_category1: rawProduct.categoryPath,
                item_category2: productGender,
                item_category3: rawProduct.thirdLevelCategory,
                item_category4: rawProduct.fourthLevelCategory,
                item_category5: rawProduct.fifthLevelCategory,
                item_list_name: 'free_product',
                item_list_id: this.helper.getListId(),
                index: index,
                item_sustainable: rawProduct.isGreen ? 'sustainable_item' : 'classic_item',
                discount: rawProduct.price && rawProduct.price.sales ? rawProduct.price.sales.value.toFixed(2) : 0.00
            };
            product = this.helper.formatProductForAnalytics(product);
            let pushObject = {
                event: 'view_item',
                ss_event_id: Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                ecommerce: {
                    currency: this.helperData.currency,
                    item_list_name: product.item_list_name,
                    item_list_id: product.item_list_id,
                    items: [product]
                },
            };
            this.push({ecommerce: null});
            this.push(pushObject);

            $('.analytics-quickview').find('.analytics.productListingItem').attr({
                'data-discount': product['discount'],
                'data-price': rawProduct.bonusUnitPriceValue,
                'data-item_on_sale': 'yes'
            });

            if (product.coupon !== 'no_promotion') {
                localStorage.setItem('bonusProductPromotion', product.coupon);
            }
        });
    }

    prepareEinsteinProducts (data) {
        // Take only the viewed elements
        let container = $(data.container).find('.slick-slide.slick-active ' + this.analyticsDataContainer);
        var checkVisibility = false;
        var hasPrice = true;
        const itemListName = data.type;
        const itemListId = this.helper.getListId(container, 'sfcc');
        if ($(data.container).find('.slick-slide.slick-active ' + this.analyticsDataContainer).data()) {
            hasPrice = $(data.container).find('.slick-slide.slick-active ' + this.analyticsDataContainer).data().price;
        }
        if ($(data.container).find('.slick-slide.slick-active').css('display') === 'none' || !hasPrice) {
            container = $(data.container).find('.slick-slide');
            checkVisibility = true;
        }
        let skippedProducts = localStorage.getItem('suggestedProductsWithNullPrice');
        if (skippedProducts) {
            skippedProducts = checkVisibility ? 0 : parseInt(skippedProducts);
        }
        if (!checkVisibility && skippedProducts > 0) {
            let elementsToAdd = $(data.container).find('.slick-slide').filter(function () {
                return ($(this).data('slick-index') >= container.length && $(this).data('slick-index') < (container.length + skippedProducts));
            });
            container.push(...elementsToAdd);
        }

        let items = [];
        for (let i = 0; i < container.length; i++) {
            if (checkVisibility) {
                if (!container.eq(i).hasClass('slick-cloned') || container.eq(i).data('slick-index') < 0 || container.eq(i).css('display') === 'none') {
                    continue;
                }
            }
            let obj = !checkVisibility ? container.eq(i).data() : container.eq(i).find(this.analyticsDataContainer).data();
            let isNotVisible = !checkVisibility ? (container.eq(i).closest('.slick-slide').css('display') === 'none') : (container.eq(i).css('display') === 'none');
            if (!obj.price || isNotVisible) {
                continue;
            }
            obj.item_list_name = itemListName;
            obj.item_list_id = itemListId;
            var item = this.helper.formatProductForAnalytics(obj);
            item.index = this.pushedItems.length;
            items.push(item);
            this.pushedItems.push(i);
            this.pushedSkus.push(obj.item_id + obj.item_variant);
        }

        var _self = this;

        $('body').on('afterChange', '.js-suggestedProducts, ' + data.container, function (event, slick, currentSlide, nextSlide) {
            let allActive = $(data.container).find('.slick-slide.slick-active ' + _self.analyticsDataContainer);
            if (checkVisibility) {
                allActive = $(data.container).find('.slick-slide');
            }
            // All elements for position
            let allProducts = $(data.container).find('.slick-slide ' + _self.analyticsDataContainer);
            let totalProductsNumber = allProducts.length;

            let items = [];

            for (let i = 0; i < allActive.length; i++) {
                if (checkVisibility) {
                    if (!allActive.eq(i).hasClass('slick-cloned') || allActive.eq(i).data('slick-index') < 0 || allActive.eq(i).css('display') === 'none') {
                        continue;
                    }
                }
                let obj = !checkVisibility ? allActive.eq(i).data() : allActive.eq(i).find(_self.analyticsDataContainer).data();
                obj.item_list_name = itemListName;
                obj.item_list_id = itemListId;
                var item = _self.helper.formatProductForAnalytics(obj);
                item.index = _self.pushedSkus.length;
                if (item.index < 0) {
                    item.index += totalProductsNumber;
                }
                if (_self.pushedSkus.indexOf(obj.item_id + obj.item_variant) === -1) {
                    items.push(item);
                    _self.pushedItems.push(item.index);
                    _self.pushedSkus.push(obj.item_id + obj.item_variant);
                }
            }

            _self.log('Pushing for ' + data.value, true);

            if (items.length > 0) {
                let pushObject = {
                    'event': 'view_item_list',
                    'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                    'ecommerce': {
                        'currency': _self.helperData.currency,
                        'item_list_name': itemListName,
                        'item_list_id': itemListId,
                        'items': items
                    }
                };

                _self.push({ecommerce: null});
                _self.push(pushObject);
                _self.pushedIndexes[data.class] = items.length;
                _self.log('Indexes pushed to: ', true);
                _self.log(_self.pushedIndexes);
            }
        });

        if (items.length > 0) {
            let pushObject = {
                'event': 'view_item_list',
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'ecommerce': {
                    'currency': _self.helperData.currency,
                    'item_list_name': itemListName,
                    'item_list_id': itemListId,
                    'items': items
                }
            };
            _self.push({ecommerce: null});
            _self.push(pushObject);
            _self.pushedIndexes[data.class] = items.length;
            _self.log('Indexes pushed to: ', true);
            _self.log(_self.pushedIndexes);
        }
    }

    prepareEinsteinRecentlyProducts (data) {
        let analyticsItems = [];
        let container = $(data.container).find('.js-prodTile');
        const itemListName = data.type;
        const itemListId = this.helper.getListId(data.container, 'sfcc');
        for (let i = 0; i < container.length; i++) {
            let analyticsItem = $(container[i]).find(this.analyticsDataContainer);
            $(analyticsItem).attr('data-index', i);
            $(analyticsItem).attr('data-item_list_name', itemListName);
            $(analyticsItem).attr('data-item_list_id', itemListId);

            if (!$(container[i]).hasClass('slick-cloned')) {
                analyticsItems.push(this.helper.formatProductForAnalytics($(analyticsItem).data()));
            }
        }

        let list = data.type;
        if (list && typeof list === 'string') {
            this.pushObjectMax({
                items: analyticsItems,
                i: 0,
                l: 8,
                itemListName: list,
                itemListId: this.helper.getListId(container)
            });
        }
    }

    prepareProductObservers () {
        var _self = this;
        $('body').on('search:showMoreContentLoaded', function (e) {
            _self.pushAllLists();
        });
    }

    prepareBestSellersObservers () {
        var _self = this;

        if (!$('.cc-slotCarousel_bestseller').length) {
            return;
        }

        let analyticsItems = [];
        const itemListName = 'best_sellers';
        const itemListId = this.helper.getListId(null, 'sfcc');
        $('.cc-slotCarousel_bestseller ' + _self.analyticsDataContainer).toArray().forEach((item, index) => {
            $(item).attr('data-index', index);
            $(item).attr('data-item_list_name', itemListName);
            $(item).attr('data-item_list_id', itemListId);

            if (!$(item).parent().hasClass('slick-cloned')) {
                analyticsItems.push(_self.helper.formatProductForAnalytics($(item).data()));
            }
        });
        this.pushObjectMax({
            items: analyticsItems,
            i: 0,
            l: 8,
            itemListName: itemListName,
            itemListId: itemListId
        });
    }

    prepareTilesObservers () {
        var _self = this;

        $('body').on('click', '.wishlistItemCards .line-item-name', function (e) {
            const $target = $(this).closest('.product-info');
            _self.pushSelectInteraction($target);
        });

        // Click event only for an item
        $('body').on('click', '.cc-prodTile-imageContainer-image, .js-prodTile-name', function (e) {
            if ($('.page').data('action') === 'Home-Show') {
                const container = $(e.currentTarget).closest('.js-prodTile').find(_self.analyticsDataContainer);
                container.attr('data-item_list_name', 'carousel-home');
            }
            _self.pushSelectInteraction($(e.currentTarget).closest('.js-prodTile'));
        });

        // productClick on quick view
        // Attribute data-index must be valued based on product clicked
        $('body').on('click touchstart', '.analytics-quickview', function (e, data) {
            var position = 0;
            var list = 'listing';

            try {
                list = localStorage.getItem('listtype');
                position = parseInt(localStorage.getItem('lastClickedPosition')) || 0;
            } catch (e) {}

            // No position if quickview of bonus product
            if ($(e.currentTarget).closest('.add-freegift').length !== 0) {
                position = '';
            }
            $(this).find('.analytics')
                .attr({
                    'data-item_list_name': list,
                    'data-index': list === 'cart' ? '' : position
                });

            const target = $(this).closest('.product-name');
            _self.pushSelectInteraction(target);
        });

        var alreadyStart = false;

        // Click + Product Details for quickview of an item
        $('body').on('product:analyticsProductDetails', function (e, data) {
            // const $target = $(this).closest('.product');
            if (!alreadyStart) {
                const target = $(data);
                _self.pushSelectInteraction(target);
                _self.pushSelectQuickViewInteraction(data);
                alreadyStart = true;
            }
        });

        $('body').on('click', '.js-cross-product .image-container', function (e, data) {
            var target = $(this);
            if ($(e.currentTarget).closest('.slick-track').length !== 0) {
                return;
            }
            _self.pushSelectQuickViewInteraction(target);
        });

        $('body').on('click', '.product-image', function (e, data) {
            // const $target = $(this).closest('.product');
            const isFromCartList = $(this).closest('.cart-line-item').length > 0;
            if (isFromCartList) {
                return _self.pushSelectInteractionInCart($(this));
            }
            if ($('.page').data('action') === 'Wishlist-Show') {
                return;
            }
            if ($(e.currentTarget).closest('.wishlist-minicart').length !== 0) {
                return;
            }
            if ($(e.currentTarget).closest('.analytics-mini-cart').length !== 0) {
                return;
            }
            let target = $(this).closest('.product-quickview').find(_self.analyticsDataContainer);
            target.data('list', localStorage.getItem('listtype'));
            target = target.closest('h4');
            if (target.closest('.add-freegift').length !== 0) {
                $(target).find('.analytics').attr({
                    'data-index': ''
                });
            }

            _self.pushSelectInteraction(target);
        });

        $('body').on('click', '.cart-line-item .line-item-name a', function (e, data) {
            return _self.pushSelectInteractionInCart($(this));
        });

        $('body').on('product:productLanding', function (e) {
            const target = $(e.currentTarget).find('.product-quickview');
            _self.pushSelectInteraction(target);
            _self.pushSelectQuickViewInteraction(target);
        });

        $('body').on('click', '.js-orderAgain-carousel__item, .js-orderAgain-modal__viewProduct, .js-analytics-order-details__card', function (e) {
            let $currentTarget;
            let $objectData;

            if ($('.tingle-modal-box.rightModalAttribute').length) {
                $currentTarget = $('.tingle-modal-box.rightModalAttribute');
                $objectData = $currentTarget.find('.clickAdditionalAttributes');
            } else {
                $currentTarget = $(e.currentTarget).closest('.js-analytics-product-info').find('.analytics.productData');
                $currentTarget = $currentTarget.length ? $currentTarget : $(e.currentTarget);
                $objectData = $currentTarget.find('.analytics.productListingItem');
            }

            if (!$currentTarget.length || !$objectData.length) {
                return;
            }

            const itemListId = $('.page').data('action') === 'OrderAgain-ShowCart' ? 'shopping_bag' : 'my_orders_and_returns';
            $objectData.data().item_list_id = itemListId;
            $objectData.data().item_list_name = 'buy_it_again';

            _self.pushSelectInteraction($currentTarget, $objectData.data().index || 0);
        });
    }

    pushSelectInteractionInCart (target) {
        var itemToProvide = target.parents('.cart-line-item');

        this.fillAllListData();

        const itemListName = 'cart';
        const itemListId = this.helper.getListId();
        let container = itemToProvide.find('.analytics.checkout.checkout-product');
        let pushData = {
            ...container.data(),
            item_list_name: itemListName,
            item_list_id: itemListId
        };
        var products = this.helper.formatProductForAnalytics(pushData);

        let pushObject = {
            'event': 'select_item',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': itemListName,
                'item_list_id': itemListId,
                'items': [products]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    prepareObservers () {
        var _self = this;

        let recentlyViewed = $('.cc-slotCarousel_recentlyView');
        if (recentlyViewed.length) {
            _self.prepareEinsteinRecentlyProducts({
                container: recentlyViewed,
                type: 'recently_viewed'
            });
            _self.pushList('recently_viewed');
        }

        $('body').on('product:crossSellLoaded', function (e, data) {
            if (!data || !_self.analyticsSuggestionShouldTrigger) {
                _self.prepareProductObservers();
                $('body').trigger('analytics:productsSuggestions', {
                    associatedClass: '.js-completeLook-slider',
                    listType: 'complete_your_look'
                });
                $('body').trigger('analytics:productsSuggestions', {
                    associatedClass: '.js-promoCarousel',
                    listType: 'complete_the_promo'
                });
                _self.analyticsSuggestionShouldTrigger = false;
            }
        });

        $('body').on('listing:einsteinloadedSuggestedProducts', function (e, data) {
            _self.listsAvailable = _self.helper.getAvailableListTypes(_self.listingItemsBaseClass);
            if ($(data.container).closest('.hiddenGiftCard').length === 1) {
                var dataGiftcard = data;
                var triggerOnlyOnce = false;
                $('body').on('einsteinGiftCardRecommendation', function (e) {
                    if (!triggerOnlyOnce) {
                        _self.prepareEinsteinProducts(dataGiftcard);
                        _self.pushList('suggested_products');
                        triggerOnlyOnce = true;
                    }
                });
            } else {
                if (data.type === 'you_may_also_like') {
                    _self.pushList('you_may_also_like');
                } else {
                    _self.prepareEinsteinProducts(data);
                    if (data.type !== 'suggested_products') {
                        _self.pushList('suggested_products');
                    }
                }
            }
        });

        $('body').on('product:crossSellError', function (e, data) {
            _self.prepareProductObservers();
            _self.pushList();
        });

        $('body').on('bonusProduct:quickviewOpen', function (e, data) {
            _self.pushBonusProductDetails(data);
        });

        $('body').on('listing:filter_or_sort_applied', function (e, data) {
            const itemListName = _self.helper.formatString(data.listType);
            const itemListId = _self.helper.getListId();
            for (let index = 0; index < data.dataArray.length; index++) {
                data.dataArray[index] = _self.helper.formatProductForAnalytics(
                    {
                        ...data.dataArray[index],
                        item_list_name: itemListName,
                        item_list_id: itemListId
                    });
                data.dataArray[index].index = index;
            }
            localStorage.setItem('listtype', itemListName);
            _self.listsAvailable = _self.helper.getAvailableListTypes(_self.listingItemsBaseClass);
            _self.pushObjectMax({
                items: data.dataArray,
                i: 0,
                l: 8,
                itemListName: itemListName,
                itemListId: itemListId
            });
        });

        $('body').on('product:crossSellMiniCartLoaded', function (e, data) {
            _self.listsAvailable = _self.helper.getAvailableListTypes(_self.listingItemsBaseClass);
            _self.pushList('complete_your_look_minicart');
        });

        $('body').on('analytics:productsSuggestions', function (e, { associatedClass, listType }) {
            let analyticsDivElements = $(associatedClass + ' ' + _self.analyticsDataContainer).toArray();

            if (!analyticsDivElements.length || !_self.analyticsSuggestionShouldTrigger) {
                return;
            }

            const itemListName = _self.helper.formatString(listType);
            const itemListId = _self.helper.getListId(associatedClass);
            let analyticsItems = [];
            analyticsDivElements.forEach((item, index) => {
                item.setAttribute('data-index', index);
                item.setAttribute('data-item_list_name', itemListName);
                item.setAttribute('data-item_list_id', itemListId);
                analyticsItems.push(_self.helper.formatProductForAnalytics(
                    {
                        ...$(item).data(),
                        item_list_name: itemListName,
                        item_list_id: itemListId
                    }));
            });
            _self.pushObjectMax({
                items: analyticsItems,
                i: 0,
                l: 8,
                itemListName: itemListName,
                itemListId: itemListId
            });
        });

        $('body').on('orderAgain:carouselLoaded', function (e) {
            _self.listsAvailable = _self.helper.getAvailableListTypes(_self.listingItemsBaseClass);
            _self.pushList('buy_it_again');
        });

        $('body').on('seeSimilar:modalOpened', function (e) {
            _self.listsAvailable = _self.helper.getAvailableListTypes(_self.listingItemsBaseClass);
            _self.pushList('similar_products');
        });

        $('body').on('analytics:orderAgainModalOpened', function (e, data) {
            const $currentTarget = data.target;
            const $objectData = $currentTarget.find('.clickAdditionalAttributes');

            if (!$currentTarget.length || !$objectData.length) {
                return;
            }

            const itemListId = $('.page').data('action') === 'OrderAgain-ShowCart' ? 'shopping_bag' : 'my_orders_and_returns';
            $objectData.data().item_list_id = itemListId;
            $objectData.data().item_list_name = 'buy_it_again';

            _self.pushOrderAgainViewItem($currentTarget);
        });
    }

    pushObjectMax (data) {
        if (data.items.length > 0) {
            // Condition for do-while
            let condition = true;
            // Number of items
            var nItems = data.items.length;
            do {
                if (data.items.length > 0) {
                    let pushObject = {
                        'event': 'view_item_list',
                        'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                        'ecommerce': {
                            'currency': this.helperData.currency,
                            'item_list_name': data.itemListName,
                            'item_list_id': data.itemListId,
                            'items': data.items.slice(data.i, data.l)
                        }
                    };

                    this.push({ecommerce: null});
                    this.push(pushObject);
                    // Increment of pointer
                    data.i += 8;
                    data.l += 8;
                    // Decrement of items pushed
                    nItems -= 8;
                    // Condition exit do-while
                    if (nItems <= 0) {
                        condition = false;
                    }
                }
            } while (condition);
        }
    }
}

const obj = new AnalyticsListings();
module.exports = obj;
